const Reports = () => {
    return (
        <div>
            <h1>Reports</h1>
            <p>View detailed reports on employee attendance, productivity, and system analytics.</p>
        </div>
    );
};

export default Reports;
